const ApplicationStatusEnum = {
  STACK: "STACK",
  SHORTLIST: "SHORTLIST",
  INTERVIEW: "INTERVIEW",
  HIRED: "HIRED",
  REJECTED: "REJECTED"
};

export default ApplicationStatusEnum;
